@use "../../../scss/settings/colors";
.checkbox_container {
  margin-top: 16px;
}

.modal_container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); // Fondo oscuro semi-transparente
}

@mixin buttonMixin {
  font-family: 'Regular Inter', sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  min-width: 100px;
  height: 44px;
  border-radius: 8px;
  text-transform: none;
  }

.submission-button {
  @include buttonMixin;
  background-color: colors.$purple-light !important;
  color: colors.$brand-purple !important;
  &:hover{
      color: colors.$base-white !important;
      background-color: colors.$purple-light-2 !important;
      }
    }


.closing-button {
  @include buttonMixin ;
  background-color: colors.$base-white  !important;
  color: colors.$base-black !important;
  text-transform: capitalize !important;
  &:hover{
      background-color: colors.$gray-variant !important;
    }
  }

.textfield_multiline {
  margin-top: 16px; // Ensure spacing from elements above
  margin-bottom: 16px; // Ensure spacing from elements below
  border: none; // Ensure no extra border is applied
  outline: none; // Remove any outline that might appear as a border
}

// ---------- Responsive ----------
.modal_container {
  box-sizing: border-box;
  padding: 16px;
  overflow-y: auto;
}
